<script lang="ts" setup>
import { usePowerUrl } from "@/use/common";

const url = usePowerUrl();
</script>
<template>
  <img :src="url" alt="" class="icon-base" crossorigin="anonymous" />
</template>
